export default "__VITE_ASSET__febda97b__"